import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.053 5.466a5.73 5.73 0 0 0 4.09 8.166l1.427-2.473q-.185.023-.38.023a3.18 3.18 0 0 1-2.82-1.709zM2.524 3.89a7.001 7.001 0 1 0 11.336 8.22A7.001 7.001 0 0 0 2.524 3.89m1.313.389 1.428 2.47a3.18 3.18 0 0 1 2.926-1.93h4.763A5.72 5.72 0 0 0 8.19 2.272a5.71 5.71 0 0 0-4.354 2.006m9.755 1.812h-2.855c.399.532.636 1.193.636 1.909 0 .626-.18 1.21-.493 1.702l-2.315 4.013a5.728 5.728 0 0 0 5.027-7.624M9.87 8.91a1.91 1.91 0 1 0-3.38-.045l.051.088.023.044a1.908 1.908 0 0 0 3.231.04l.048-.083z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })